import * as types from './mutation-types'
import * as authTypes from '../authentication/mutation-types'
import consumablesService from '../../services/consumables'
import { createServiceCall } from '../actionsUtil'

export const getConsumablesStatus = createServiceCall({
  mainAction: types.GET_CONSUMABLES_STATUS_REQUEST,
  serviceFunction: consumablesService.getConsumablesStatus,
  successAction: types.GET_CONSUMABLES_STATUS_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_CONSUMABLES_STATUS_FAILURE
})
